// import { gapi } from 'gapi-script';
import React, { useEffect, useState } from 'react';
// import { GoogleLogin, GoogleLogout } from 'react-google-login';
// import { FcGoogle } from "react-icons/fc";
import { useCreateUrlHook } from "./hook";
import Logo from '../../Images/Logo.png'
import './LoginScreen.css';

import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router-dom';
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs";
import { FaArrowRight, FaLock, FaUserAlt } from 'react-icons/fa';
import { useSelector } from 'react-redux';


const LoginScreen = () => {

  const navigate = useNavigate()

  // const clientId = "582720039712-v2knfr3lhnntlqu8kr8h7lo91nb9prak.apps.googleusercontent.com"

  // const [profile, setProfile] = useState([]);

  // const [showloginButton, setShowloginButton] = useState(true);
  // const [showlogoutButton, setShowlogoutButton] = useState(false);

  const [validated, setValidated] = useState(false);

  const [user, setUser] = useState({
    username: "",
    password: ""
  });

  const handleInputs = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setUser((currentUser) => ({ ...currentUser, [name]: value }))
  }

  const { doSubmitUrl } = useCreateUrlHook();

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    setValidated(true);
    if (form.checkValidity() === false) {
      event.stopPropagation();
    }
    else {
      doSubmitUrl(user);
    }
  };

  // Google authentication code 
  // useEffect(() => {
  //   const initClient = () => {
  //     gapi.client.init({
  //       clientId: clientId,
  //       scope: '',
  //     });
  //   };
  //   gapi.load('client:auth2', initClient);
  // }, []);

  // const onSuccess = (res) => {
  //   setProfile(res.profileObj);
  //   setShowloginButton(false);
  //   setShowlogoutButton(true);
  // };

  // const onFailure = (err) => {
  //   console.log('Login Failed:', err);
  // };

  // const onSignoutSuccess = () => {
  //   setProfile();
  //   alert("You have been logged out successfully");
  //   console.clear();
  //   setShowloginButton(true);
  //   setShowlogoutButton(false);
  // };

  const isLoggedIn = useSelector(state => state.userData.isLoggedIn)

  useEffect(() => {
    if (isLoggedIn) {
      navigate('/list')
    }
  }, [isLoggedIn, navigate])

  const [viewPassword, setViewPassword] = useState(false)

  return (
    <main className="login-page">
      <div className="login-page__texture" aria-hidden="true" />
      <div className="login-layout">
        <section className="login-identity" aria-label="Foxberry Technologies">
          <div className="login-identity__topline">
            <span className="login-identity__seal">
              <img src={Logo} alt="" />
            </span>
            <span className="login-identity__office">fxurl.co</span>
          </div>

          <div className="login-identity__copy">
            <p className="login-eyebrow">SERVICES · PRODUCTS</p>
            <h1> <b>fxurl.co</b> </h1>
            <span className="login-identity__rule" aria-hidden="true" />
            <p className="login-identity__statement">Innovating the future.<br />Connecting communities.</p>
          </div>

          <div className="login-identity__bottomline">
            <span>Foxberry Technologies</span>
          </div>
        </section>

        <section className="login-form-panel" aria-labelledby="login-title">
          <div className="login-form-panel__header">
            <span className="login-form-panel__kicker">ACCOUNT ACCESS</span>
            <span className="login-form-panel__status"><span aria-hidden="true" /> SECURE SIGN IN</span>
          </div>

          <div className="login-form-panel__intro">
            <h2 id="login-title">Welcome back<span>.</span></h2>
            <p>Sign in to continue to your account.</p>
          </div>

          <Form noValidate validated={validated} onSubmit={handleSubmit} className="login-form">
            <Form.Group className="login-field" controlId="login-username">
              <Form.Label>Username</Form.Label>
              <div className="login-field__control">
                <Form.Control
                  required
                  type="text"
                  name="username"
                  autoComplete="username"
                  value={user.username}
                  onChange={handleInputs}
                  placeholder="Enter your username"
                />
                <FaUserAlt className="login-field__icon" aria-hidden="true" />
              </div>
              <Form.Control.Feedback type="invalid">Please enter your username.</Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="login-field" controlId="login-password">
              <Form.Label>Password</Form.Label>
              <div className="login-field__control">
                <Form.Control
                  required
                  type={viewPassword ? 'text' : 'password'}
                  name="password"
                  autoComplete="current-password"
                  value={user.password}
                  onChange={handleInputs}
                  placeholder="Enter your password"
                />
                <button
                  type="button"
                  className="login-password-toggle"
                  onClick={() => setViewPassword((visible) => !visible)}
                  aria-label={viewPassword ? 'Hide password' : 'Show password'}
                  aria-pressed={viewPassword}
                >
                  {viewPassword ? <BsEyeFill aria-hidden="true" /> : <BsEyeSlashFill aria-hidden="true" />}
                </button>
              </div>
              <Form.Control.Feedback type="invalid">Please enter your password.</Form.Control.Feedback>
            </Form.Group>

            <button type="submit" className="login-submit">
              <span>Sign in</span>
              <FaArrowRight aria-hidden="true" />
            </button>
          </Form>

          <div className="login-form-panel__footer">
            <FaLock className="login-form-panel__lock" aria-hidden="true" />
            <span>Your connection is protected</span>
          </div>
        </section>
      </div>

      <footer className="login-footer">
        <span>© {new Date().getFullYear()} Foxberry Technologies</span>
        <span>SERVICE PORTAL</span>
      </footer>
    </main>
  )
}

export default LoginScreen